const domains = [
  'Global',
  'Admin',
  'Client',
  'Login',
  'Billing'
]

export default domains
